import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { User } from '@ps/auth-data-access';

import { EntitlementApi } from '../api/entitlement.api';
import { FeatureEntitlement } from '../models/entitlement.model';

@Injectable({ providedIn: 'root' })
export class EntitlementService {
  private readonly _api = inject(EntitlementApi);

  public getEntitlements(user: User): Observable<FeatureEntitlement[]> {
    return this._api.getEntitlements(user);
  }
}
